import { IStorageItem } from '../Interfaces/IStorageItem';
import StorageService from './storageService';
import { breadcrumbs } from '../Breadcrumbs/breadcrumbService';
import { Page } from '../Enums/Page';
import { constants } from '../constants';

class ViewService {
    private readonly storageService: StorageService;

    constructor() {
        this.storageService = new StorageService(sessionStorage);
    }

    public setupLearingAimView(learnAimRef: string, learningAimTitle: string, page: Page): void {
        const storageItem = Object.assign(this.currentStorageItem, { learnAimRef, learningAimTitle, page: page });
        this.storageService.store(constants.storageKey, storageItem);
        breadcrumbs.buildBreadcrumb(storageItem);
    }
  
    public setupStandardView(standardCode: string, standardName: string, page: Page) : void {
        const storageItem = Object.assign(this.currentStorageItem, { standardCode, standardName, page});
        this.storageService.store(constants.storageKey, storageItem);
        breadcrumbs.buildBreadcrumb(storageItem);
    }

    public setupFrameworkView(frameworkCode: string, programType: string, pathwayCode: string, academicYear: string, page:Page): void {
        const storageItem = Object.assign(this.currentStorageItem, { frameworkCode, programType, pathwayCode, academicYear, page });
        this.storageService.store(constants.storageKey, storageItem);
        breadcrumbs.buildBreadcrumb(storageItem);
    }

    private get currentStorageItem(): IStorageItem {
        return this.storageService.retrieve(constants.storageKey) as IStorageItem;
    }
}

export const viewService = new ViewService();